import { render, staticRenderFns } from "./itemDelete.vue?vue&type=template&id=7205c274"
import script from "./itemDelete.vue?vue&type=script&lang=js"
export * from "./itemDelete.vue?vue&type=script&lang=js"
import style0 from "./itemDelete.vue?vue&type=style&index=0&id=7205c274&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports